<template>
  <div class="new-detail">
    <div class="new-detail__container">
      <Breadcrumbs :last-label="breadcrumbTitle" />
      <div v-if="isLoading" class="new-detail__status" role="status">
        Загрузка новости…
      </div>
      <div
        v-else-if="!hasNews"
        class="new-detail__status"
        role="status"
      >
        Новость не найдена или временно недоступна.
      </div>
      <div v-else class="new-detail__layout">
        <NewsRelatedList :current-id="itemNews.id" />
        <div class="new-detail__article">
          <AppSectionNewsDetails :news_item="itemNews" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Breadcrumbs from '@/components/BreadCrumbs.vue'
import { actionTypesNews } from '@/store/modules/news'
import AppSectionNewsDetails from '@/components/News/SectionNewsDetails.vue'
import NewsRelatedList from '@/components/News/NewsRelatedList.vue'

export default {
  name: 'AppItemNewsDetail',
  components: {
    AppSectionNewsDetails,
    Breadcrumbs,
    NewsRelatedList,
  },
  metaInfo() {
    const newsTitle = this.itemNews && this.itemNews.title
    return {
      title: newsTitle
        ? `${newsTitle} | Алтайский краевой клинический перинатальный центр ДАР`
        : 'Новости | Алтайский краевой клинический перинатальный центр ДАР',
      meta: [
        {
          name: 'description',
          content:
            (this.itemNews && this.itemNews.description) ||
            'Новости перинатального центра ДАР',
        },
        {
          name: 'keywords',
          content:
            'пациентам, алтайский краевой клинический перинатальный центр, перинатальный центр, дар',
        },
      ],
    }
  },
  computed: {
    ...mapState({
      itemNews: (state) => state.news.itemNews,
      isLoading: (state) => state.news.isLoading,
    }),
    breadcrumbTitle() {
      return (this.itemNews && this.itemNews.title) || ''
    },
    hasNews() {
      return !!(this.itemNews && this.itemNews.id && this.itemNews.title)
    },
  },
  watch: {
    '$route.params.id'(id) {
      if (id) {
        this.loadNewsItem(id)
      }
    },
  },
  mounted() {
    this.loadNewsItem(this.$route.params.id)
  },
  methods: {
    loadNewsItem(id) {
      if (!id) return
      this.$store.dispatch(actionTypesNews.getNewsItem, id)
    },
  },
}
</script>
